/* global mp */

import {MPContext} from 'common/mp-context';
import {Persistence} from 'common/report/persistence';
import {parseUrlQueryParams} from 'common/util/index';

export class CohortsMPContext extends MPContext {
  constructor() {
    super(...arguments);

    if (this.isStandalone) {
      const urlQueryParams = parseUrlQueryParams();
      this.debug = !!urlQueryParams.debug;
      this.persist = this.debug && urlQueryParams.persist;
      if (this.persist) {
        try {
          this.persistedState = JSON.parse(this.persistence.get(`state`));
        } catch (err) {
          this.persistedState = null;
        }
      } else {
        this.persistence.remove(`state`);
      }
    } else {
      // Globals
      this.debug = false;
      const {globals} = mp.report;
      this.isBlockedOnPeople = globals.blocking.is_blocked_people;
    }
  }

  get persistenceKey() {
    return `cohorts-1.0.0`;
  }

  get persistence() {
    if (!this._persistence) {
      let namespaceVars = [this.persistenceKey];
      if (this.projectId) {
        namespaceVars = namespaceVars.concat([this.projectId, this.userId]);
      }
      this._persistence = new Persistence(namespaceVars.join(`:`));
    }

    return this._persistence;
  }
}
